var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'lodash';

import DataItem from './DataItem';

var PropertyInfo = function () {
    function PropertyInfo(properetyInfoDescriptorObj, schedule) {
        _classCallCheck(this, PropertyInfo);

        this._descriptor = properetyInfoDescriptorObj;
        this._schedule = schedule;
    }

    _createClass(PropertyInfo, [{
        key: 'isRequired',
        value: function isRequired() {
            return this._descriptor.required;
        }
    }, {
        key: 'isUnique',
        value: function isUnique() {
            return this._descriptor.isUnique;
        }
    }, {
        key: 'isEditable',
        value: function isEditable() {
            return this._descriptor.editable;
        }
    }, {
        key: 'getName',
        value: function getName() {
            return this._descriptor.id;
        }
    }, {
        key: 'getLabel',
        value: function getLabel() {
            return this._descriptor.label;
        }
    }, {
        key: 'getType',
        value: function getType() {
            return this._descriptor.valueType;
        }
    }, {
        key: 'getOrder',
        value: function getOrder() {
            return this._descriptor.order;
        }
    }, {
        key: 'getSchedule',
        value: function getSchedule() {
            return this._schedule;
        }
    }, {
        key: 'getCurrency',
        value: function getCurrency() {
            return this._descriptor.currency;
        }
    }, {
        key: 'getAvailableValues',
        value: function getAvailableValues() {
            return this._descriptor.availableTypeListValues;
        }
    }, {
        key: 'getDisplayKeyFromAvailableValuesByCode',
        value: function getDisplayKeyFromAvailableValuesByCode(code) {
            if (!code) {
                return '';
            }

            return _.find(this.getAvailableValues(), function (val) {
                return val.code === code;
            }).displayKey;
        }
    }, {
        key: 'checkDataItemIsUniqueInSchedule',
        value: function checkDataItemIsUniqueInSchedule(dataItem) {
            return this.getSchedule().dataItemIsUniqueInSchedule(dataItem);
        }
    }, {
        key: 'getDefaultValue',
        value: function getDefaultValue(onItemChange) {
            var defaultDescriptor = this._descriptor.defaultValue ? _.cloneDeep(this._descriptor.defaultValue) : _defineProperty({}, DataItem.typeToPropertyName(this.getType()), undefined);
            return new DataItem(defaultDescriptor, this, onItemChange);
        }
    }]);

    return PropertyInfo;
}();

export default PropertyInfo;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/models/schedules/PropertyInfo.js
// module id = 163
// module chunks = 0